import styled, { keyframes, css } from 'styled-components';
import {white} from '../../loggedout/shared-styles/Colors'
import { device } from '../../../utils/responsive_utilities';

export const Subjects = styled.div`
  width: 75rem;
  height: 52rem;
  margin: auto;
  @media ${device.Phone} {
    width: 100%;
    height: 55rem;
    position: relative;
    top: -17%;
  }
  @media ${device.PhoneTabletLandscape} {
    width: 45.6rem;
    height: unset;
    transform: scale(1.1);
  }
`;

export const HiddenClickContainer = styled.div`
  position: absolute;
  width: 22rem;
  height: 22rem;
  background: ${white};
  transform: translate(-50%, -50%);
  top: 50%;
  left: 32%;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
  &:nth-of-type(2) {
    left: 70%;
  }

  @media ${device.Phone} {
    width: 13rem;
    height: 13rem;
    left: 52%;
    top: 48%;
    &:nth-of-type(2) {
      left: 52%;
      top: 79%;
    }  
  }

  @media ${device.PhoneTabletLandscape} {
    width: 11rem;
    height: 11rem;
  }
`;

const translateUpperEntry = keyframes`
  0% {
    opacity: 0;
    transform: translateY(40rem);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const translateLowerEntry = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20rem);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const translateUpperExit = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20rem);
  }
`;

const translateLowerExit = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-40rem);
  }
`;


const rotateUpper = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const rotateLower = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(5deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const GradesContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  > div {
    padding: 7rem 0 0;
  }
`;

export const LoadthroughContainer = styled.div`
  width: 100%;
  position: relative;
  img {
    position: absolute;
    &:nth-of-type(1) {
      left: 20%;
      top: 8.4rem;
      animation: ${translateLowerEntry} 1s ease-in-out forwards, ${rotateUpper} 2s linear infinite 1s, ${translateLowerExit} 1s ease-in-out 3s forwards;
      transform-origin: center right;
    }
    &:nth-of-type(2) {
      right: 40%;
      top: 6.2rem;
      animation: ${translateLowerEntry} 1s ease-in-out forwards, ${rotateUpper} 2s linear infinite 1s, ${translateLowerExit} 1s ease-in-out 3s forwards;
      transform-origin: center right;
    }
    &:nth-of-type(3) {
      left: 34%;
      top: 26.0rem;
      animation: ${translateUpperEntry} 1s ease-in-out forwards, ${rotateLower} 2s linear infinite 1s, ${translateUpperExit} 1s ease-in-out 3s forwards;
      transform-origin: center left;
    }
    &:nth-of-type(4) {
      right: 24%;
      top: 22.8rem;
      animation: ${translateUpperEntry} 1s ease-in-out forwards, ${rotateLower} 2s linear infinite 1s, ${translateUpperExit} 1s ease-in-out 3s forwards;
      transform-origin: center left;
    }
    @media ${device.Phone} {
      width: 30%;
      &:nth-of-type(1) {
        left: 10%;
        top: 8.4rem;
      }
      &:nth-of-type(2) {
        right: 20%;
        top: 11.2rem;
      }
      &:nth-of-type(3) {
        left: 13%;
        top: 22rem;
      }
      &:nth-of-type(4) {
        right: 21%;
        top: 27.8rem;
      }
    }

    @media ${device.Tablet}{
      &:nth-of-type(1) {
        left: 7%;
        top: 15.4rem;
      }
      &:nth-of-type(2) {
        right: 24%;
        top: 10.2rem;
      }
      &:nth-of-type(3) {
        left: 28%;
        top: 32rem;
      }
      &:nth-of-type(4) {
        right: 5%;
        top: 28.8rem;
      }
    }

    @media ${device.PhoneTabletLandscape} {
      width: 15%;
      &:nth-of-type(1) {
        top: 6.2rem;
      }
      &:nth-of-type(2) {
        top: 4rem;
      }
      &:nth-of-type(3) {
        top: 12rem;
      }
      &:nth-of-type(4) {
        top: 10rem;
      }
    }


    @media ${device.TabletLandscape} {
      &:nth-of-type(2) {
        right: 28%;
        top: 6.2rem;
      }
      &:nth-of-type(3) {
        left: 34%;
        top: 28rem;
      }
      &:nth-of-type(4) {
        right: 12%;
        top: 25.8rem;
      }
    }
  }
  
  ${(props) => props.selectedSubject === 'ela' ? 
    css `
      img {
        &:nth-of-type(1) {
          left: 58%;
          top: 7.0rem;
        }
        &:nth-of-type(2) {
          right: 57%;
          top: 8.0rem;
        }
        &:nth-of-type(3) {
          left: 44%;
          top: 29.0rem;
        }
        @media ${device.PhoneTabletLandscape} {
          &:nth-of-type(1) {
            top: 4.0rem;
          }
          &:nth-of-type(2) {
            top: 5.0rem;
          }
          &:nth-of-type(3) {
            top: 12.0rem;
          } 
        }
      }
    ` : null
  }
`;